import * as requestFromServer from "./UserLogsCrud";
import { callTypes, userLogSlice } from "./UserLogsSlice";

const {actions} = userLogSlice;

export const getUserLogs = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getUserLogs(queryParams)
    .then(response => {
      dispatch(actions.userLogsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getException = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getException(id)
    .then(response => {
      dispatch(actions.exceptionFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const cleanExceptionState = () => dispatch => {
  dispatch(actions.exceptionStateCleaned());
};

export const cleanUserLogsState = () => dispatch => {
  dispatch(actions.userLogsStateCleaned());
};